"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIcomoon = _interopRequireDefault(require("react-icomoon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const iconSet = require("./selection.json");
const Icon = ({
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_reactIcomoon.default, _extends({
    iconSet: iconSet
  }, props, {
    color: "var(--menu-primary-icon)"
  }));
};
var _default = exports.default = Icon;
module.exports = exports.default;